// @flow

export default {
  TEXT: 'text',
  PASSWORD: 'password',
  RADIO: 'radio',
  HIDDEN: 'hidden',
  CHECKBOX: 'checkbox'
};
